import { CustomEntryPrio } from "./interfaces";

export const customEntryPrioToApi = (prio: CustomEntryPrio[]) =>
    prio.reduce((acc, p, i) => p * 10 ** i + acc, 0);

export const customEntryPrioFromApi = (prio: number) => {
    const arr = [];
    let rest = prio;

    while (rest > 0) {
        arr.push(rest % 10);
        rest = Math.floor(rest / 10);
    }

    return arr as CustomEntryPrio[];
};
